export const KNOWLEDGEBASE_FILE_LIST_GRID_CLASS =
  "grid grid-cols-[minmax(0,4fr)_minmax(8rem,1fr)_minmax(7rem,1fr)_minmax(2.5rem,auto)] items-center gap-x-6"

export const getKnowledgebaseFileListGridClass = () =>
  KNOWLEDGEBASE_FILE_LIST_GRID_CLASS

export const KNOWLEDGEBASE_FILE_LIST_FIRST_COLUMN_CLASS =
  "grid min-w-0 grid-cols-[1.5rem_minmax(0,1fr)] items-start gap-x-S"

export const KNOWLEDGEBASE_FILE_LIST_FIRST_COLUMN_CLASS_NO_TAGS =
  "grid min-w-0 grid-cols-[1.5rem_minmax(0,1fr)] items-center gap-x-S"
